<template>
    <div v-show="showContent && isMobile" :class="dvnClass">
        <svg @click="displayOptions" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.70711 0.292893C8.09763 0.683418 8.09763 1.31658 7.70711 1.70711L3.41421 6H15C15.5523 6 16 6.44771 16 7C16 7.55228 15.5523 8 15 8H3.41421L7.70711 12.2929C8.09763 12.6834 8.09763 13.3166 7.70711 13.7071C7.31658 14.0976 6.68342 14.0976 6.29289 13.7071L0.292893 7.70711C0.105357 7.51957 0 7.26522 0 7C0 6.73478 0.105357 6.48043 0.292893 6.29289L6.29289 0.292893C6.68342 -0.0976311 7.31658 -0.0976311 7.70711 0.292893Z" fill="currentColor"/>
        </svg>
        <slot></slot>
        <svg @click="displayOptions" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z" fill="currentColor"/>
        </svg>
    </div>
</template>
<script>
    export default {
        name: 'DetailsViewNav',
        props:{
            isMobile: {type: Boolean},
            showContent: {type: Boolean},
            dvnClass: {type: String, default: 'carOptionsnav'}
        },
        methods:{
            displayOptions(){
                this.$emit('change-view', true);
            }
        }
    }
</script>
<style lang="scss" scoped>
    .carOptionsnav,
    .financeNav{
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 1rem 0 2rem;

        span{ 
            font-size: .875rem;
            color: $grayDarkCol;
            b{font-family: $medium;}
        }
        svg{ color: $grayDarkCol;}
    }

    .financeNav{
        padding: 1rem 1.125rem 2rem;
        svg, span{ color: $whiteCol;}
    }
</style>